import { ComponentPropsWithoutRef, useState } from 'react'

import Image from 'next/image'

import { cn } from '~shared/utils/cn'
import { LeadForm } from './lead-form'
import { SwingIcon1, SwingIcon2 } from './swing-icon'
import { ImageSrc } from '~shared/types/utils'
import { replacePrepositionsWhitespaces } from '~shared/utils/replace-prepositions-whitespaces'
import { SuccessViewBoundary } from './success-view'

export interface LeadFormSectionProps extends ComponentPropsWithoutRef<'div'> {
  title: string
  personImg: ImageSrc
  decorationImg: ImageSrc
}

export const LeadFormSection = (props: LeadFormSectionProps) => {
  const { className = '', title, personImg, decorationImg, ...rest } = props

  const [isSuccess, setIsSuccess] = useState(false)

  return (
    <section className={cn('', className)} {...rest}>
      <SuccessViewBoundary isSuccess={isSuccess} className='mx-auto'>
        <div className='relative bg-secondary rounded-[24px] md:rounded-[40px] lg:rounded-[64px] xl:p-[60px] lg:p-[40px] md:p-[24px] p-[16px]'>
          <SwingIcon1 className='hidden xl:block text-primary absolute right-0 bottom-0' />
          <SwingIcon2 className='hidden lg:block xl:hidden text-primary absolute right-0 bottom-0' />
          <p className='relative typo-section-heading font-medium'>
            {replacePrepositionsWhitespaces(title)}
          </p>
          <div
            className={cn(
              'relative flex justify-stretch',
              'mt-[16px] md:mt-[24px] lg:mt-[40px] xl:mt-[60px]'
            )}>
            <LeadForm
              className='lg:w-[556px] 2xl:w-[700px] w-full'
              onSuccess={() => setIsSuccess(true)}
            />
            <div className='top-0 left-0 lg:block hidden relative xl:ml-[120px] ml-[40px] xl:mb-[-18px] xl:translate-y-[-18px] 2xl:mb-[-66px] 2xl:translate-y-[-66px]'>
              <div className='relative h-[254px] w-[214px] xl:size-[258px] 2xl:size-[364px] rounded-[40px] overflow-hidden'>
                <Image
                  src={personImg}
                  fill
                  alt='Person'
                  className='absolute top-0 left-0 object-cover select-none'
                  draggable={false}
                />
              </div>

              <Image
                src={decorationImg}
                width={258}
                height={258}
                alt='Decoration'
                className='object-contain xl:block hidden 2xl:hidden absolute left-[170px] top-[75px] select-none'
                draggable={false}
              />
              <Image
                src={decorationImg}
                width={356}
                height={356}
                alt='Decoration'
                className='object-contain 2xl:block hidden absolute left-[222px] top-[54px] select-none'
                style={{ width: 356, height: 356 }}
                draggable={false}
              />
            </div>
          </div>
        </div>
      </SuccessViewBoundary>
    </section>
  )
}
